<template>
  <aside class="left-container floatl">
    <div class="scroll">
      <div class="scroll-bar" id="scrollBar"></div>
      <el-row class="main-nav" id="scroll" v-if="flag">
        <el-menu :default-active="$route.path" id="nav" unique-opened router>
          <template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
            <el-submenu :index="index+''" v-if="!item.leaf" :key="index" class="submenu">
              <template slot="title">
                <img :src="item.icon" alt="">
                <p>{{item.name}}</p>
              </template>
              <el-menu-item v-if="!child.hidden" v-for="(child, i) in item.children" :index="child.path" :key="i"
                            class="submenu-item" @mousedown.native.prevent="checkFrom(child.path)">
                <i :class="child.iconCls"></i>{{child.name}}
              </el-menu-item>
            </el-submenu>
            <!--针对没有children的部分-->
            <el-menu-item v-if="item.leaf && item.children.length>0" :index="item.children[0].path" :key="index"
                          class="single-item">
              <img :src="item.icon" alt="" v-if="$route.path != item.children[0].path">
              <img :src="item.iconActive" alt="" v-if="$route.path == item.children[0].path">
              <p>{{item.children[0].name}}</p>
            </el-menu-item>
          </template>
        </el-menu>
      </el-row>
    </div>
  </aside>
</template>

<script>
  //韩金辰180711 整理
  import {mapMutations} from "vuex";

  export default {
    data() {
      return {
        flag: false,
      }
    },
    methods: {
      ...mapMutations(["saveWorkSquareInfo", "workSquareIsEditMethods"]),
      checkFrom(to) {
        console.log('to', to)
        //如果从发布岗位，或发布任务页跳出则弹框提示，跳出去后数据被清空
        //postTask相关判断，等三期上线时候再启用
        if (to === '/workNews') {
          window.open('http://wxmc.myfmes.cn/')
          return false
        }
        if ((this.$route.path == '/postJob' && to != '/postJob')
        // ||( this.$route.path == '/postTask' && to != '/postTask' )
        ) {
          // 暂时不加这个判断，task来了之后要增加判断
          // if(vm.$store.state.postJobHasData){
          this.$confirm('跳转后将清空本页未保存数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            this.$router.push({path: to});
          }).catch(() => {
            return false
          });
        }
      },
      loadMessage() {
        //这里充分信任这三类session中只能存在一类，如果不是只能看运气。。很可能传参错误
        this.$http({
          method: "GET",
          url: '/rest/sysUser/sysUserLogin',
          params: {
            account: sessionStorage.getItem("usersPG") || sessionStorage.getItem("usersUL") || sessionStorage.getItem("user"),
            password: sessionStorage.getItem("passwordsPG")|| sessionStorage.getItem("passwordsUL") || sessionStorage.getItem("passwords")
          }
        }).then(res => {
          //之前正式库没有这个webid，现在有了的话，就不用下面这一段了
          // if (sessionStorage.getItem("usersPG")) {
          //   res.data.webAuthLst.push({
          //     auth: 2,
          //     pId: 26,
          //     webId: 27,
          //     webLevel: 2,
          //     webName: "促销员数据",
          //   })
          // }
          //把用户密码发给后台，res中的webAuthLst是允许查看的页面，仅显示其中的webid与router里面相匹配的栏目，其他的设置为hidden
          //这里也只是导航中看不到而已，直接链接还是能访问的，但有些有权限控制的接口将不能返回数据
          let webIdArr = []
          res.data.webAuthLst.map(item => {
            webIdArr.push(item.webId)
          })

          let routes = this.$router.options.routes
          routes.map(item1 => {
            item1.children.map(item2 => {
              if (!item2.hidden) {
                if (webIdArr.indexOf(item2.webId) == -1) {
                  item2.hidden = true
                }
              }
            })
          })
          routes.map(item1 => {
            let show = false
            item1.children.map(item2 => {
              if (!item2.hidden) {
                show = true
              }
            })
            if (!show) {
              item1.hidden = true
            }
          })
          // console.log('routes trans finished ! ', routes)
          //权限拿到才给他看侧边栏
          this.flag = true
        })
      }
    },
    mounted() {
      this.loadMessage()
    },
    watch: {
      '$route'(to, from) {
        //清空发布岗位第一页的数据
        this.saveWorkSquareInfo(null)
        //应该加判断，如果是从发布岗位出去，则置为false
        this.workSquareIsEditMethods(false)
        // console.log('router')
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "../../common/styles/variable.scss";

  .left-container {
    width: 120px;
    height: calc(100% - 70px);
    overflow: hidden;
    background-color: $theme-color;
    .scroll {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      &:hover .scroll-bar {
        opacity: 0.3;
      }
      .scroll-bar {
        position: absolute;
        top: 0;
        right: 0;
        width: 5px;
        background: #000;
        opacity: 0;
        z-index: 999;
        border-radius: 2.5px;
        transition: opacity 1s;
      }
      .main-nav {
        width: 115%;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/layout/leftBar.vue